type GlassSphereColors = {
	clear: number;
	ambient: number;
};

type NebulaColors = {
	color1: string;
	color2: string;
	color3: string;
};

const GLASS_SPHERE_LIGHT_COLORS: GlassSphereColors = {
	clear: 0xedf4f7,
	ambient: 0xe3eef3,
};

const GLASS_SPHERE_COLORS: Record<string, GlassSphereColors> = {
	'tokyo-night': { clear: 0x1a1b26, ambient: 0x24283b },
	'catppuccin-mocha': { clear: 0x1e1e2e, ambient: 0x313244 },
	'catppuccin-latte': { clear: 0xeff1f5, ambient: 0xccd0da },
	gruvbox: { clear: 0x282828, ambient: 0x3c3836 },
	'rose-pine-moon': { clear: 0x191724, ambient: 0x26233a },
	'rose-pine-dawn': { clear: 0xfaf4ed, ambient: 0xf2e9e1 },
	'osaka-jade': { clear: 0x111c18, ambient: 0x23372b },
	'shades-of-purple': { clear: 0x2d2b55, ambient: 0x3b386d },
	supabase: { clear: 0x171717, ambient: 0x1c1c1c },
	github: { clear: 0x0d1117, ambient: 0x161b22 },
	'one-dark-pro': { clear: 0x282c34, ambient: 0x2c313c },
};

const NEBULA_LIGHT_COLORS: NebulaColors = {
	color1: '#54b9d6',
	color2: '#8bd3dc',
	color3: '#dbe8ee',
};

const NEBULA_COLORS: Record<string, NebulaColors> = {
	'tokyo-night': { color1: '#7aa2f7', color2: '#bb9af7', color3: '#1a1b26' },
	'catppuccin-mocha': {
		color1: '#89b4fa',
		color2: '#cba6f7',
		color3: '#1e1e2e',
	},
	'catppuccin-latte': {
		color1: '#1e66f5',
		color2: '#8839ef',
		color3: '#eff1f5',
	},
	gruvbox: { color1: '#83a598', color2: '#d3869b', color3: '#282828' },
	'rose-pine-moon': {
		color1: '#9ccfd8',
		color2: '#c4a7e7',
		color3: '#191724',
	},
	'rose-pine-dawn': {
		color1: '#56949f',
		color2: '#907aa9',
		color3: '#faf4ed',
	},
	'osaka-jade': {
		color1: '#509475',
		color2: '#2dd5b7',
		color3: '#111c18',
	},
	'shades-of-purple': {
		color1: '#b362ff',
		color2: '#ff628c',
		color3: '#2d2b55',
	},
	supabase: { color1: '#3ecf8e', color2: '#6ee7b7', color3: '#171717' },
	github: { color1: '#58a6ff', color2: '#bc8cff', color3: '#0d1117' },
	'one-dark-pro': {
		color1: '#61afef',
		color2: '#c678dd',
		color3: '#282c34',
	},
};

export function getGlassSphereColors(
	theme: string,
	isLight: boolean,
): GlassSphereColors {
	if (isLight) return GLASS_SPHERE_LIGHT_COLORS;
	return GLASS_SPHERE_COLORS[theme] ?? { clear: 0x071828, ambient: 0x0a2232 };
}

export function getNebulaColors(theme: string, isLight: boolean): NebulaColors {
	if (isLight) return NEBULA_LIGHT_COLORS;
	return (
		NEBULA_COLORS[theme] ?? {
			color1: '#6fcbff',
			color2: '#3a8b9f',
			color3: '#071828',
		}
	);
}
